import React, { ReactNode } from "react";
import { api } from "api/api";
import MacroButton, {
  MacroBulletItem,
  MacroBulletList,
  MacroContentStack,
} from "./MacroButton.component";
import { DialogContentText } from "@mui/material";

export default function CreatePriceKeyPVAButton() {
  function InfoMessage(): ReactNode {
    return (
      <MacroContentStack>
        <DialogContentText>
          This process will add the ::PriceKey PVA to every property that has
          the ::MLP PVA for a product line. See additional details below:
        </DialogContentText>
        <MacroBulletList>
          <MacroBulletItem>
            The ::PriceKey PVA will not be added to a property that already has
            it. So this process can be run multiple times without any issues.
          </MacroBulletItem>
          <MacroBulletItem>
            If this product line does not already have the ::PriceKey PVA, it
            will be created at the product line level. This occurs even if the
            ::PriceKey PVA is not added to any properties.
          </MacroBulletItem>
          <MacroBulletItem>
            If the ::MLP PVA does not have the <strong>FLOAT</strong> data type
            or the ::PriceKey PVA is already created and does not have the{" "}
            <strong>STRING</strong> data type, this process will abort.
          </MacroBulletItem>
        </MacroBulletList>
        <DialogContentText>
          Are you sure you want to continue?
        </DialogContentText>
      </MacroContentStack>
    );
  }

  return (
    <MacroButton
      performApiCall={(productLineId: string) =>
        api.addPriceKeyPVAs(productLineId)
      }
      apiCallDependencies={[]}
      buttonLabel={`Add ::PriceKey to Product Line`}
      dialogTitle={`Add ::PriceKey to Product Line`}
      tooltipText={`Adds ::PriceKey to the product line.`}
      processingMessage={`Adding ::PriceKey to product line. This may take a while.`}
      completionMessage="Addition completed. See detailed results below."
      timeOutMessage="Addition process timed out. See details below."
      informationContent={InfoMessage()}
      timeOutFailureDescription={`Request timed out. This could be due to an especially large number of ::PriceKey instances to add.`}
      pvasUpdated={true}
      recommendValidation={false}
    />
  );
}
